import { Box, Typography } from '@mui/material'

import { useEffect } from 'react'

import { loginRequest } from '@features/config/auth'
import { useMsal } from '@azure/msal-react'

import { useAppSnackbar } from '@services/hooks/AppSnackbar'
import { useDialog } from '@components/Dialog/use'

import Dialog from '@components/Dialog'

import Styles from './style'

export const Auth = () => {
    const { config, open} = useDialog()
    const { instance } = useMsal()
    const { show: showAppSnackbar } = useAppSnackbar()

    useEffect(() => { displaySimpleModal() }, [])

    const displaySimpleModal = () => {
        open('Access to LZ Cockpit ', null, 'sm')
    }

    const handleApply = () => {
        instance.loginPopup(loginRequest).catch(e => {
            showAppSnackbar(`${e}`, 'error')
        })
    }

    return (
        <Box style={Styles.wrapper}>
            <Dialog
                config={config}
                handleApply={handleApply}
                applyLabel={'Login with technical account'}
                disabledClickForClose
                noCtaClose
                noCtaCancel
            >
                <Typography variant={'body2'}>Please login you with your technical account.</Typography>
                <Typography variant={'body2'}>Your corporate account login does not work to log to LZ cockpit.</Typography>
            </Dialog>
        </Box>
    )
}

export default Auth